<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <template v-if="!mandat.ID && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Mandat inexistant</b-alert>
        </b-col>
      </b-row>
    </template>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row v-if="loaded && mandat.ID" class="mx-0 mb-3">
      
      <b-col>
        <b-card class="bg-light shadow">
          <h6 class="card-title">Mandat : {{ mandat.ID.value}} <span v-if="mandat.ref_creancier.value">(Votre référence : {{ mandat.ref_creancier.value }})</span></h6>
          <b-row>
            <b-col lg="12">
              <b-alert
                variant="danger"
                show
                v-if="mandat.status.value !== 'open'"
              >
                Ce mandat est {{ mandat.status.i18n }}
                <span
                  v-if="
                    mandat.status.value == 'stopped' &&
                    mandat.popUpAgenda.value &&
                    toDate(mandat.popUpAgenda.value)
                  "
                >
                  - Mis à l'agenda à la date du
                  {{ toDate(mandat.popUpAgenda.value) }}</span
                >
                <span v-else> - Sans date à l'agenda </span>
              </b-alert>
            </b-col>
            <b-col lg="12">
              <b-row
                v-if="
                  mandat.note_cloture.value !== '' &&
                  mandat.status.value == 'closed'
                "
                class="mb-3"
              >
                <b-col lg="12">
                  <b-card class="bg-light shadow">
                    <b-card-title title-tag="h6">
                      Note de clotûre :
                    </b-card-title>
                    <p v-html="nl2br(mandat.note_cloture.value)"></p>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" lg="6" class="mb-3">
                  <b-card class="shadow bg-light">
                    <b-card-title title-tag="h6" class="mb-0">
                      <div class="d-flex justify-content-between">
                        <div>
                          Débiteur :
                          <b-link
                            :to="{
                              name: 'debtorView',
                              params: {
                                id: mandat.debiteurID.value,
                                edit: true,
                              },
                            }"
                            >{{ mandat.debiteur.nom_complet.value }}</b-link
                          >
                          <span v-if="mandat.debiteur.gsm.value">
                            ({{ mandat.debiteur.gsm.value }})</span
                          >
                          <b-badge
                            variant="danger"
                            class="ml-2"
                            v-if="
                              mandat.debiteur.totalMandatOpenClosed.value > 0
                            "
                            >{{
                              mandat.debiteur.totalMandatOpenClosed.value
                            }}</b-badge
                          >
                        </div>
                      </div>
                    </b-card-title>
                    <b-card-body class="p-1">
                      <b-row>
                        <mh-input
                          mh-class="col-6"
                          label="Tél."
                          field="gsm"
                          :readonly="!edit"
                          :table="mandat.debiteur"
                          @change="save()"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          label="Mail"
                          field="email"
                          :readonly="!edit"
                          :table="mandat.debiteur"
                          @change="save()"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          label="Mandats"
                          field="totalMandatOpenClosed"
                          readonly
                          :table="mandat.debiteur"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          label="ID"
                          field="ID"
                          readonly
                          :table="mandat.debiteur"
                        ></mh-input>
                        <mh-input
                          mh-class="col-12"
                          field="lastCourrierDate"
                          readonly
                          :table="mandat.debiteur"
                          labelColsLg="6"
                        ></mh-input>
                        <mh-input
                          mh-class="col-12"
                          field="lastNegoDate"
                          :table="mandat"
                          readonly
                          labelColsLg="6"
                        ></mh-input>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col md="12" lg="6" class="mb-3">
                  <b-card class="shadow bg-light">
                    <b-card-title title-tag="h6" class="mb-0">
                      <div class="d-flex justify-content-between">
                        <div>Adresse des courriers débiteur pour ce mandat</div>
                      </div>
                    </b-card-title>
                    <b-card-body class="p-1">
                      <b-row>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_nom_soc"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_titre"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_prenom"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_nom"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-12"
                          labelColsLg="2"
                          field="courrier_rue1"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-12"
                          labelColsLg="2"
                          field="courrier_rue2"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_codepostal"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="courrier_localite"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="offset-lg-6 col-6"
                          field="courrier_pays"
                          :readonly="!edit"
                          :table="mandat"
                        ></mh-input>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" lg="6">
                  <b-card class="mb-2 shadow" no-body>
                    <b-tabs v-model="note_tabindex" card content-class="mt-2">
                      <b-tab title="Notes" active>
                        <b-button
                          size="sm"
                          icon
                          title="Ajouter une note"
                          @click="note_ajouter('public', ['prive', 'public'])"
                          class="mb-3"
                          ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
                        ></b-button>
                        <b-table
                          style="
                            display: block;
                            max-height: 503px;
                            overflow: auto;
                          "
                          v-if="mandat.notes.length > 0"
                          id="notesTable"
                          responsive
                          small
                          fixed
                          striped
                          hover
                          :fields="notesFields"
                          :items="
                            mandat.notes.filter((x) => x.type == 'public')
                          "
                        >
                          <template v-slot:cell(read)="data">
                            <div v-html="toBadge(data.item.read)"></div>
                          </template>
                          <template v-slot:cell(when)="data">{{
                            toDate(data.item.when)
                          }}</template>
                          <template v-slot:cell(initiale)="data">{{
                            data.item.initiale
                          }}</template>
                          <template v-slot:cell(content)="data">
                            <div
                              class="note-content"
                              v-html="data.item.content"
                            ></div>
                          </template>
                        </b-table>
                        <b-card-body v-else>
                          <b-alert show>Pas de notes</b-alert>
                        </b-card-body>
                      </b-tab>
                     
                      <b-tab
                        lazy
                        :active="tab == 'courriers'"
                        title="Courriers"
                      >
                        <template #title>
                          Courriers
                          <span v-if="mandat.debiteur_courriers.length > 0"
                            >({{ mandat.debiteur_courriers.length }})</span
                          >
                        </template>
                        <b-table
                          v-if="mandat.debiteur_courriers.length > 0"
                          hover
                          responsive
                          small
                          :fields="mailsFields"
                          :items="mandat.debiteur_courriers"
                        >
                          <template v-slot:cell(date)="data">{{
                            toDate(data.item.date)
                          }}</template>

                          <template #row-details="data">
                            <b-card>
                              <div v-html="nl2br(data.item.content)"></div>
                            </b-card>
                          </template>
                          <template v-slot:cell(actions)="data">
                            <b-button
                              class="mr-2 btn-xs"
                              size="sm"
                              @click="data.toggleDetails"
                            >
                              <b-icon-eye-fill
                                v-if="!data.detailsShowing"
                              ></b-icon-eye-fill>
                              <b-icon-eye-slash-fill
                                v-else
                              ></b-icon-eye-slash-fill>
                            </b-button>

                            <b-button
                              size="sm"
                              class="mr-3 btn-xs"
                              target="_blank"
                              :href="courrier_pdf(data.item.ID)"
                              ><b-icon-printer-fill></b-icon-printer-fill
                            ></b-button>
                          </template>
                        </b-table>
                        <b-alert v-else show class="mt-3"
                          >Pas encore de courrier pour ce débiteur</b-alert
                        >
                      </b-tab>
                      <b-tab
                        lazy
                        :active="tab == 'documents'"
                        title="Documents"
                      >
                        <template #title>
                          Documents
                          <span v-if="mandat.documents.length > 0"
                            >({{ mandat.documents.length }})</span
                          >
                        </template>
                        <Documents
                          object="mandat"
                          :id="mandat.ID.value"
                        ></Documents>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-col>
                <b-col lg="6">
                  <b-card class="mb-2 shadow bg-light">
                    <b-row>
                      <mh-input
                        mh-class="col-4"
                        label="Statut"
                        field="status"
                        :table="mandat"
                        readonly
                      ></mh-input>
                      <mh-input
                        mh-class="col-4"
                        label="Priorité"
                        field="priorite"
                        :readonly="!edit"
                        :table="mandat"
                      ></mh-input>
                      <mh-input
                        :mh-class="$store.getters.isAdmin ? 'col-3' : 'col-4'"
                        label="Négo"
                        field="negotiateurID"
                        :readonly="!edit"
                        :table="mandat"
                      ></mh-input>

                      <mh-input
                        mh-class="col-4"
                        field="popUpAgenda"
                        :readonly="!edit"
                        :table="mandat"
                      ></mh-input>
                      <mh-input
                        mh-class="col-4"
                        label="SMS"
                        field="sms"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save()"
                      ></mh-input>
                      <mh-input
                        mh-class="col-4"
                        label="RA"
                        field="rechercheAdresse"
                        :readonly="!edit"
                        :table="mandat.debiteur"
                      ></mh-input>
                      <b-col lg="4">
                        <b-row>
                          <mh-input
                            mh-class="col-12"
                            label="Création"
                            field="date_creation"
                            readonly
                            :table="mandat"
                          ></mh-input>
                          <mh-input
                            mh-class="col-12"
                            label="Ouverture"
                            field="date_ouverture"
                            readonly
                            :table="mandat"
                          ></mh-input>
                          <mh-input
                            mh-class="col-12"
                            label="Clôture"
                            field="date_cloture"
                            readonly
                            :table="mandat"
                          ></mh-input>
                        </b-row>
                      </b-col>
                      <b-col lg="8">
                        <b-row>
                          <mh-input
                            mh-class="col-12"
                            label="Position"
                            field="debiteur_state_machineID"
                            readonly
                            :table="mandat"
                            labelColsLg="2"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            label="Changement"
                            field="dsm_switch_date"
                            readonly
                            :table="mandat"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            label="Rap. Avocat"
                            field="lastAvocatRappelDate"
                            readonly
                            :table="mandat"
                          ></mh-input>
                          <mh-input
                            label="Mode"
                            mh-class="col-6"
                            field="modeID"
                            :readonly="!edit"
                            :table="mandat"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            field="toVisit"
                            :readonly="!edit"
                            :table="mandat"
                            labelColsLg="4"
                          ></mh-input>
                        </b-row>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-between mt-3">
                      <b-button
                        size="sm"
                        v-if="mandat.arrangementID.value != 0"
                        variant="success"
                        :to="{
                          name: 'settlement',
                          params: { id: mandat.arrangementID.value },
                        }"
                        ><span style="color: #fff"
                          >Arrangement en cours ({{
                            mandat.arrangementID.value
                          }})</span
                        ></b-button
                      >
                      <b-button size="sm" v-else variant="danger"
                        >Pas d'arrangement en cours</b-button
                      >
                    </div>
                  </b-card>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <warrant-invoices
                    :key="render + 1"
                    :id="mandat.ID.value"
                    :createInvoice="mandat.arrangementID.value == 0"
                    @change="load"
                    ref="warrant_invoices"
                  ></warrant-invoices>
                </b-col>
                <b-col lg="8">
                  <warrant-indemnities
                    :key="render + 3"
                    @change="load"
                    :id="mandat.ID.value"
                  ></warrant-indemnities>
                </b-col>
                <b-col lg="4">
                  <b-card class="mb-3 bg-light shadow">
                    <b-card-title title-tag="h6"
                      >Valeurs des indemnités</b-card-title
                    >

                    <b-table
                      small
                      striped
                      hover
                      :items="IndemnitiesValues"
                      :tbody-tr-class="indemnitiesClass"
                    ></b-table>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="mb-3">
              <bd-table-list
                ref="paymentsRef"
                nobreadcrumb
                nofacets
                nosearch
                title="Paiements"
                bdTable="payement"
                :key="componentKey"
                :actions="payementsActions"
                :query="query"
                :fields="fields"
                :Api="Api"
              >
              </bd-table-list>
            </b-col>
            <b-col lg="12">
              <b-card class="mb-2 shadow bg-light">
                <b-card-title title-tag="h6">Résumé : </b-card-title>
                <warrant-summary
                  :id="mandat.ID.value"
                  :key="render"
                ></warrant-summary>
              </b-card>
            </b-col>
            <b-col lg="12 mt-2">
              <b-card class="mb-2 shadow bg-light">
                <b-card-title title-tag="h6">Évolution</b-card-title>
                <highcharts :options="charted" ref="chart"></highcharts>
                <b-table
                  id="synopsis"
                  striped
                  small
                  hover
                  :items="synopsis"
                  responsive
                  :fields="synopsisFields"
                  @row-hovered="synopsisRowHovered"
                >
                  <template v-slot:cell(principal)="data">
                    {{ data.item.principal.toFixed(2) }} €
                    <span v-if="data.item.deltaPrincipal < 0">
                      <b-icon-arrow-down-right
                        variant="success"
                      ></b-icon-arrow-down-right>
                    </span>
                    <span v-else>
                      <b-icon-arrow-up-right
                        variant="danger"
                      ></b-icon-arrow-up-right>
                    </span>
                  </template>
                  <template v-slot:cell(solde)="data">
                    {{ data.item.solde.toFixed(2) }} €
                    <span v-if="synopsis[data.index - 1]">
                      <span
                        v-if="synopsis[data.index - 1].solde > data.item.solde"
                      >
                        <b-icon-arrow-down-right
                          variant="success"
                        ></b-icon-arrow-down-right>
                      </span>
                      <span v-else>
                        <b-icon-arrow-up-right
                          variant="danger"
                        ></b-icon-arrow-up-right>
                      </span>
                    </span>
                    <span v-else>
                      <b-icon-arrow-up-right
                        variant="danger"
                      ></b-icon-arrow-up-right>
                    </span>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-ajouter-note"
      :size="breakpoint"
      title="Ajouter une nouvelle note"
      hide-footer
    >
      <WarrantNote
        @change="load()"
        @close="$bvModal.hide('modal-ajouter-note')"
        note_id="new"
        :authorized="notesAuthorized"
        :warrant_id="warrant_id"
      ></WarrantNote>
    </b-modal>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import warrants from "@/services/warrants";
import DateTime from "@/services/DateTime.js";
import WarrantInvoices from "@/components/WarrantInvoices";
import WarrantIndemnities from "@/components/WarrantIndemnities";
import WarrantSummary from "@/components/WarrantSummary";
import Documents from "@/components/Documents";
import WarrantNote from "@/components/WarrantNote";
import BdTableList from "@/components/BdTableList";
import payments from "@/services/payments.js";
import { Chart } from "highcharts-vue";
export default {
  name: "warrant-view",
  components: {
    MhInput,
    WarrantInvoices,
    WarrantIndemnities,
    WarrantSummary,
    WarrantNote,
    BdTableList,
    highcharts: Chart,
    Documents,
  },

  data() {
    return {
      busy: false,
      listener: null,
      tabindex: 0,
      note_tabindex: 0,
      expandInfo: true,
      edit: false,
      notesAuthorized: [],
      numberOfNotesNoteRead: 0,
      render: 0,
      payment_id: null,
      warrant_id: null,
      note_id: null,
      note_type: "prive",
      date_cloture: new Date().toJSON().slice(0, 10),
      pauseMandat: true,
      cloture_body: "",
      stopList: [],
      reasonsSelected: [],
      stop_step: 0,
      charted: {},
      chartLoaded: false,
      componentKey: 0,
      Api: payments,
      renderFields: 0,
      query: [],
      payments: [],
      synopsisFields: [
        {
          key: "period",
          label: "Période",
        },
        {
          key: "display",
          label: "Mouvement(s)",
        },
        {
          key: "principal",
          label: "Principal",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "deltaPrincipal",
          label: "Delta",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "interet",
          label: "Intérêt",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "indemnite",
          label: "Indemnités",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "solde",
          label: "Solde",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
      ],
      fields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "virement":
                return "Virement";
              case "cheque":
                return "Chèque";
              case "liquide":
                return "Liquide";
              default:
                return "Inconnu";
            }
          },
        },
        {
          key: "factureID",
          label: "N° de facture",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return '<a href="/invoice/view/' + value + '">' + value + "</a>";
            }
            return "<i>En attente de facturation</i>";
          },
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "date_encodage",
          label: "Date d'encodage",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return this.toDate(value);
          },
        },

        {
          key: "compte_societe",
          label: "Compte société",
          class: "text-center",
          sortable: false,
        },
        {
          key: "compte_debiteur",
          label: "Compte débiteur",
          class: "text-center",
          sortable: false,
        },
        {
          key: "numero_extrait",
          label: "Extrait",
          class: "text-right",
          sortable: false,
        },
        {
          key: "reception",
          label: "Réception",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "societe":
                return "Société";
              case "creancier":
                return "Créancier";
              default:
                return "N/A";
            }
          },
        },
        {
          label: "Négocié par",
          key: "negotiateur",
          class: "text-center",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          formatter: (value) => {
            return value ? value + " €" : "";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "commissionUsed",
          label: "Comm.",
          formatter: (value) => {
            return value ? value + " %" : "";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
      payementsActions: [
        {
          label: "Modifier",
          action: this.payement_modifier,
          condition: (item) => !item.factureID,
        },
        {
          label: "Supprimer",
          action: this.payement_supprimer,
          condition: (item) => !item.factureID && this.$store.getters.isSuperAdmin,
        },
      ],
      current_courrier: null,
      selected_courrier_typeID: null,
      mailsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
          thStyle: "width:200px",
        },

        {
          key: "nom",
          label: "Type",
          sortable: true,
        },

        {
          key: "type_envoiID",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case 1:
                return "Recommandé";
              case 2:
                return "Courrier";
              case 3:
                return "Remise en main propre";
              case 4:
                return "Email";
              default:
                return "N/A";
            }
          },
        },
        {
          key: "actions",
          label: "",
          class: "text-right",
          thStyle: "width:300px",
        },
      ],
      loaded: false,
      pdfPath: null,
      mandat: {},
      temp_mandat: {},
      documentsFields: [
        {
          key: "date_encodage",
          label: "Date",
          sortable: true,
        },
        {
          key: "isPrivate",
          label: "Type",
          sortable: false,
          class: "text-center",
        },
        {
          key: "intitule",
          label: "Nom",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
      ],
      notesFields: [
        {
          key: "read",
          label: "",
          thStyle: "width:50px",
        },
        {
          key: "when",
          label: "Date",
          sortable: true,
          class: "text-center",
          thStyle: "width:100px",
        },

        {
          key: "initiale",
          label: "Négo",
          sortable: true,
          class: "text-center",
          thStyle: "width:50px",
        },
        {
          key: "content",
          label: "Contenu",
          sortable: false,
          thStyle: { width: "400px" },
        },
      ],

      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          to: { name: "warrants" },
        },
      ],
      alert_commission: null,
      windowWidth: window.innerWidth,
    };
  },
  props: {
    tab: String,
  },
  computed: {
    IndemnitiesValues() {
let indemnitesArray = [
        {
          Indemnité: "Commission",
          Valeur: this.mandat.commission.value + " %",
        },
        {
          Indemnité: "Commission Négociateur",
          Valeur: this.mandat.commission_nego.value + " %",
        },
        {
          Indemnité: "Intérêt",
          Valeur: this.mandat.interet.value == "Yes" ? "oui" : "non",
        },
        {
          Indemnité: "Taux d'intérêt",
          Valeur: this.mandat.interet_taux.value + " %",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.interet_taux.value > this.mandat.taux_interet_particulier.value) ? "striked" : "",
        }
        ];
        if (this.mandat.calcul_particulier.value == "yes" && this.mandat.interet_taux.value > this.mandat.taux_interet_particulier.value){
            indemnitesArray.push({
              Indemnité: "Taux d'intérêt légal particuliers",
              Valeur: this.mandat.taux_interet_particulier.value + " %",
              Style: "italic",
            });
        }
        indemnitesArray.push({
          Indemnité: "Clause pénale",
          Valeur: this.mandat.clause_penale.value + "%",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) ? "striked" : "",
        },
        {
          Indemnité: "Indemnité minimum",
          Valeur: this.mandat.indemnite_minimum.value + " €",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) ? "striked" : "",
        });
        if (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) {
          indemnitesArray.push({
            Indemnité: "Clause pénale légale particuliers",
            Valeur: this.mandat.clause_penale_max_particulier.value + " €",
            Style: "italic"
          });
        }
        indemnitesArray.push(
        {
          Indemnité: "Frais de recouvrement",
          Valeur: this.mandat.frais_dossier.value + " €",
        },
        {
          Indemnité: "Frais de déplacement",
          Valeur: this.mandat.creancier.fraisDeplacement.value + " €",
        });
        return indemnitesArray;

    },
    breakpoint() {
      if (this.windowWidth < 550) return "sm";
      if (this.windowWidth >= 550 && this.windowWidth < 1200) return "md";
      if (this.windowWidth >= 1200) return "lg";
      return null; // This is an unreachable line, simply to keep eslint happy.
    },
    width() {
      return this.windowWidth;
    },
  },
  mounted() {
    this.listener = window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },

  destroyed() {
    window.removeEventListener("resize", this.listener);
  },
  created() {
    this.load(true);
  },
  watch: {
    $route() {
      // react to route changes...
      this.load();
    },
  },

  methods: {
    indemnitiesClass(item, type){
       if (!item || type !== 'row') return
       if (item.Style) return item.Style
       return
    },
    courrier_pdf(id) {
      return (
        this.$store.getters.url +
        "/client/courrier/" +
        id +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },

    toBadge(value) {
      if (value == "no") {
        return `<span class="badge badge-danger">Nouveau</span>`;
      }
      return "";
    },

    note_ajouter(payload, authorized = []) {
      this.warrant_id = this.mandat.ID.value;
      this.note_type = payload;
      this.notesAuthorized = authorized.length ? authorized : [this.note_type];
      this.$bvModal.show("modal-ajouter-note");
    },

    getClotureBody() {
      warrants
        .clotureBody(
          this.mandat.ID.value,
          this.date_cloture,
          this.reasonsSelected
        )
        .then((response) => {
          this.cloture_body = response.data.body;
        });
    },
    load() {
      this.busy = true;
      warrants
        .get(this.$route.params.id)
        .then((response) => {
          this.mandat = response.data;

          this.numberOfNotesNoteRead = this.mandat.notes.filter(
            (x) => x.read == "no"
          ).length;
          if (this.items.length > 2) {
            this.items.pop();
          }
          if (!this.mandat.ID) {
            this.items.push({
              text: "Mandat n° " + this.$route.params.id + " inexistant",

              active: true,
            });
            return;
          }
          this.items.push({
            text:
              "Mandat n° " +
              this.mandat.ID.value +
              " (" +
              this.mandat.creancier.nom_soc.value +
              " vs " +
              this.mandat.debiteur.nom_complet.value +
              ")",
            active: true,
          });
          if (this.mandat.popUpAgenda.value == "0000-00-00") {
            this.mandat.popUpAgenda.value = null;
          }
          if (this.mandat.lastNegoDate.value == "0000-00-00") {
            this.mandat.lastNegoDate.value = null;
          }
          if (this.mandat.date_cloture.value == "0000-00-00") {
            this.mandat.date_cloture.value = null;
          }
          this.loaded = true;
          this.query = [
            {
              sql: "mandatID = " + this.mandat.ID.value,
            },
          ];

          this.$nextTick(() => {
            this.render++;
            this.componentKey++;
            this.temp_mandat = JSON.parse(JSON.stringify(this.mandat));
          });
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
      this.loadChart();
    },

    loadChart() {
      warrants
        .evolution(this.$route.params.id)
        .then((response) => {
          if (!response.data.evolution) return;
          this.charted = {
            chart: {
              type: "area",
            },
            title: {
              text: "Évolution du solde, du principal et des paiements",
            },
            xAxis: {
              categories: Object.keys(response.data.evolution),
              tickmarkPlacement: "on",
              title: {
                enabled: false,
              },
            },
            yAxis: {
              title: {
                text: "Euros (€)",
              },
            },
            tooltip: {
              split: true,
              pointFormat:
                "{series.name}: {point.y} €<br/>Total: {point.stackTotal} €",
            },
            plotOptions: {
              area: {
                stacking: "normal",
                lineColor: "#666666",
                lineWidth: 1,
                marker: {
                  lineWidth: 1,
                  lineColor: "#666666",
                },
              },
            },
            series: [
              {
                name: "Intérêts",
                data: Object.values(response.data.evolution).map(
                  (x) => x.interet
                ),
              },
              {
                name: "Indemnités fixes",
                data: Object.values(response.data.evolution).map(
                  (x) => x.indemnite
                ),
              },
              {
                name: "Principal",
                data: Object.values(response.data.evolution).map(
                  (x) => x.principal
                ),
              },
            ],
          };
          this.synopsis = response.data.synopsis;
          this.chartLoaded = true;
        })
        .catch(() => {
          this.chartLoaded = false;
        });
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    synopsisRowHovered(item) {
      if (this.$refs.chart) {
        this.$refs.chart.chart.xAxis[0].removePlotBand();

        this.$refs.chart.chart.xAxis[0].addPlotBand({
          color: "#AAAAAA",
          from: item.chartPeriod[0],
          to: item.chartPeriod[1],
        });
      }
    },
  },
};
</script>

<style lang="scss">
.modal-xxl {
  max-width: 90% !important;
}
.note-content p {
  margin-bottom: 1px;
}
.striked {
text-decoration: line-through;
}
.italic {
font-style: italic;
}
</style>
